import { UseI18nHook } from "@core/i18n/i18n";
import { UseNavigationHook } from "@core/routing/use-navigate";
import { Notification, PatientNotificationData, PtNotificationData } from "@domain/notification/notification";
import { RoutesPath, TabPatientDetails } from "@ui/navigation/routes";
import { formatName } from "@utils/string-utils";

export class PtLeftHctNotification extends Notification {
	private get data() {
		return this.notification.data as {
			patient: PatientNotificationData;
			pt: PtNotificationData;
		};
	}

	format({ format }: UseI18nHook): string {
		return format("global.notifications.hct.ptleft", {
			patientName: formatName(this.data.patient),
			ptName: formatName(this.data.pt),
		});
	}

	onClick(navigate: UseNavigationHook): void {
		navigate(RoutesPath.PatientDetails, {
			route: { patientId: this.data.patient.id },
			query: { active: TabPatientDetails.HEALTHCARE_TAB },
		});
	}
}
